<template>
    <translates
        :item="this.product"
        :item_id="parseInt(product.id)"
        item_type="product">
    </translates>
</template>

<script>
import translates from "../../../../translates/translates";

export default {
    name: "product_translate",
    props : {
        product : {
            type : Object
        }
    },
    components : {
        translates
    },
}
</script>

<style scoped>

</style>
